<template>
    <div class="pa-2">
        <div class="mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card
                    flat
                    :width="width"
                    align="center"
                    justify="center"
                    
                >
                    <span 
                        class="mr-3 text-subtitle-1 green--text"                                         
                    > {{ studentName }}</span>                                 
                    <span 
                        class="text-subtitle-1 green--text"
                    >{{ classId }}</span>
                </v-card>
            </v-col>
        </div>

    
        <div>
            <v-card                                    
                :width="width"
                flat
                class="d-flex justify-space-around pa-2"
            >
                <div
                    align="center"
                    justify="center"
                    v-for="item in academicPeriod"
                    :key="item.title"
                >
                    <div 
                        class="text-caption blue--text font-weight-bold mr-2"
                    >
                        {{item.title}}
                    </div>
                    <div 
                        class="text-caption green--text"
                    >
                        {{item.value}}
                    </div>
                </div>
            </v-card>                                 
        </div>
    
        <div>
            <v-card
                :width="width"
                flat
                class="px-2"
            >
                <div>
                    <v-list class="py-0" dense>
                        <v-list-item
                            v-for="item in recordSummary1"
                            :key="item.title"
                            class="px-0"
                        >
                            <v-list-item-content class="py-0">
                                <v-list-item-title 
                                    class="text-caption"
                                >
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-card                               
                                width="120"                                                                                                       
                                flat
                            >
                                <v-text-field
                                    disabled
                                    filled
                                    dense
                                    outlined
                                    hide-details
                                    v-model="studentRecord[item.model]"
                                    class="text-caption pa-0"
                                    
                                ></v-text-field>
                            </v-card> 
                        </v-list-item>
                    </v-list>
                </div>
                                                
            </v-card>
        </div>
        
        <!-- Non academic records -->
        <div>
            <v-card
                :width="width"
                flat
                class="pa-2"
            >
                <v-list class="py-0" dense>
                    <v-list-item
                        v-for="record in recordSummary3"
                        :key="record.title"
                        class="px-0 pb-2"
                    >
                        <v-list-item-content class="py-0">
                            <v-list-item-title 
                                class="text-caption"
                            >
                                {{ record.title }}
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-card                               
                            width="120"                                                                                                       
                            flat
                        >
                            <v-select
                                v-if="record.select"
                                v-model="studentRecord[record.model]"
                                :disabled="record.disabled"
                                :filled="record.disabled"
                                :items="grades"
                                item-value="grade"
                                hide-details="auto"
                                outlined
                                class="text-caption text-center"
                                @change="updateRecord"
                                small-chips
                            >
                                <template v-slot:selection="{ attrs, item }">
                                    <v-chip
                                        v-bind="attrs"
                                        close
                                        tile
                                        @click:close="removeGrade(record.model)"
                                    >
                                        {{ item.grade }}
                                    </v-chip>
                                </template>

                                <template
                                    v-slot:item=data
                                > 
                                    {{ data.item.grade }} {{ data.item.description }}
                                </template> 
                            </v-select>

                            <v-text-field
                                v-else
                                v-model="studentRecord[record.model]"
                                :disabled="record.disabled"
                                :filled="record.disabled"
                                @blur="updateRecord" 
                                @input="checkNumber(record.model)"
                                dense 
                                hide-details="auto" 
                                outlined 
                                class="text-caption pa-0"
                                type="number"
                            ></v-text-field>   
                        </v-card> 
                    </v-list-item>
                </v-list>
                                                
            </v-card>
        </div>

        <!-- Form Teacher and Deans remarks -->
        <div>
            <v-card
                flat                
                class="px-2 pt-2" 
                :width="width"               
            >
                <div>
                    <v-menu
                        v-model="formTeacherCommentMenu"
                        bottom
                        origin="center center"
                        transition="scale-transition"
                        :close-on-content-click="false"
                    >   
                        <template v-slot:activator="{ on, attrs }">
                            <v-textarea                                       
                                label="Form Teacher's Remarks"  
                                v-model="studentRecord.comments"  
                                placeholder="Form Teacher's Remarks"                        
                                persistent-hint
                                dense
                                rows="5"
                                class="text-caption"
                                no-resize
                                maxlength="500"
                                :readonly="disableFormTeacherComment"
                                :filled="disableFormTeacherComment"
                                @blur="updateRecord"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                                counter
                            >                        
                            </v-textarea>
                        </template>
                        <v-card>
                            <v-card-title> Form Teacher's Remarks</v-card-title>
                                <v-card-text>
                                    <v-textarea                                       
                                        v-model="studentRecord.comments"  
                                        dense
                                        class="text-caption"
                                        maxlength="500"
                                        :readonly="disableFormTeacherComment"
                                        :filled="disableFormTeacherComment"
                                        @blur="updateRecord"
                                        outlined
                                        style="width:50vw"
                                        counter
                                    >                        
                                    </v-textarea>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="formTeacherCommentMenu = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </div>
            </v-card>
        </div>


        <div>
            <v-card
                flat                
                :width="width"
                class="px-2"               
            >
                <div class="text-center text-subtitle-2 font-weight-bold primary-text">Moral Education</div>
                <div class="d-flex justify-space-between moral-education">
                    <div class="d-flex flex-column">
                        <span class="text-caption">Grade</span>
                        <v-select
                            v-model="studentRecord.mmark"
                            outlined
                            small-chips
                            deletable-chips
                            :items="grades"
                            item-text="grade"
                            item-value="grade" 
                            hide-details
                            class="mr-2"
                            @blur="updateRecord"
                            :disabled="disabled"
                        >
                            <template v-slot:item="{ item }">
                                {{ item.grade }} {{ item.scale }}    
                            </template>
                        </v-select>
                    </div>
                    <div
                        class="d-flex flex-column"
                    >
                        <span class="text-caption">Application</span>
                        <v-select
                            v-model="studentRecord.mapp"
                            outlined
                            small-chips
                            deletable-chips
                            :items="grades2"
                            item-text="grade"
                            item-value="grade" 
                            hide-details
                            class="mr-2"
                            @blur="updateRecord"
                            :disabled="disabled"
                        >
                            <template v-slot:item="{ item }">
                                {{ item.grade }} {{ item.description }}    
                            </template>
                        </v-select>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="text-caption">Conduct</span>
                        <v-select
                            v-model="studentRecord.mcon"
                            outlined
                            small-chips
                            deletable-chips
                            :items="grades2"
                            item-text="grade"
                            item-value="grade" 
                            hide-details
                            class="mr-2"
                            @blur="updateRecord"
                            :disabled="disabled"
                        >
                            <template v-slot:item="{ item }">
                                {{ item.grade }} {{ item.description }}    
                            </template>
                        </v-select>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="text-caption">Comment</span>
                        <v-select
                            v-model="studentRecord.mcomm"
                            outlined
                            small-chips
                            deletable-chips
                            :items="comments"
                            item-text="id"
                            item-value="id" 
                            hide-details
                            @blur="updateRecord"
                            :disabled="disabled"
                        >
                            <template v-slot:item="{ item }">
                                {{ item.id }} {{ item.comment }}    
                            </template> 
                        </v-select>
                    </div>
                </div>
            </v-card>
        </div>

        <!-- Navigation Menu -->
        <div>
            <v-card
                flat
                :width="width"
                class="d-flex justify-space-between pa-2"
            >
                <v-btn 
                    class="text-caption pa-2  white--text"
                    width="15"
                    height="30"                
                    color="primary"
                    @click="previousRecord"
                    :disabled="!pagination.prev_page"                
                >
                    <div class="d-flex justify-center align-center pr-2"> 
                        <v-icon class="">mdi-chevron-left</v-icon>
                        <span>PREV</span>
                    </div>                                         
                </v-btn>
                
                <v-btn 
                    class="text-caption pa-2"
                    width="20"
                    height="30"
                    outlined
                    disabled                
                    text                
                >
                    <span class="blue--text">{{pagination.current_page}} of {{ pagination.last_page}}</span>                                                        
                </v-btn>
                
                <v-btn 
                    class="text-caption pa-2  white--text"
                    width="20"
                    height="30"
                    dark
                    color="primary"
                    @click="nextRecord"
                    :disabled="!pagination.next_page"
                >
                    <div class="d-flex justify-center align-center pl-2">
                        <span>NEXT</span>
                        <v-icon>mdi-chevron-right</v-icon>
                    </div>                                         
                </v-btn>
            </v-card>    
        </div>

    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    created(){
        this.initialize();
    },
    computed: {
        ...mapGetters({
            studentRecord: 'termReports/getSelectedStudentRecord',            
            academicYear: 'termReports/getAcademicYear',
            currentTerm: 'termReports/getCurrentTerm',
            formTeacherClass: 'termReports/getFormTeacherClass',
            table1Records: 'termReports/getTable1Records',
            pagination: 'termReports/getPagination',
            formClasses: 'termReports/getFormClassesList',
            admin: 'auth/getAdmin',
            deanFormClasses: 'termReports/getDeanFormClasses',
            editTermReports: 'admin/getEditTermReports',
            codedComments: 'termReports/getCodedComments',
        }),

        studentName () {
            return this.studentRecord.first_name + ' ' + this.studentRecord.last_name;
        },

        classId () {
            return this.studentRecord.class_id;
        },
        recordSummary1 () {
            return this.recordSummary.filter(value => value.section == 1);
        },

        recordSummary2 () {
            return this.recordSummary.filter(value => value.section == 2);
        },

        recordSummary3 () {
            return this.recordSummary.filter(value => value.section == 3);
        },

        termName () {
            let termName = '';
            if(this.currentTerm == 1) termName =  '1';
            if(this.currentTerm == 2) termName = '2';
            if(this.currentTerm == 3) termName = '3';
            return termName
        },

        
    },
    watch: {
        studentRecord: {
            handler (val) {
                this.selectedCoCurriculars = []; 
                if(val.cocurricular) this.selectedCoCurriculars = val.cocurricular.split(',');  
                this.setDisabledFields();
                this.setMusicAccess();
            }
        },

    },
    data: () => ({
        recordSummary: [
            {title: 'Student\'s ID', model: 'student_id', select: false, disabled: true, section: 1},
            // {title: 'Possible Attendances', model: 'possible_attendance', select: false, disabled: true, section: 1},
            {title: 'Possible Attendances', model: 'possible_attendance', select: false, disabled: false, section: 3},
            {title: 'Attendances Lost', model: 'times_absent', select: false, disabled: false, section: 3},
            {title: 'Number of Times Late', model: 'times_late', select: false, disabled: false, section: 3},
            {title: 'Application', model: 'app', select: true, disabled: false, section: 3},
            {title: 'Conduct', model: 'con', select: true, disabled: false, section: 3},
        ],
        academicPeriod: [
            { title: 'Academic Year', value: '' },
            { title: 'Term', value: '' },
        ],
       grades: [            
            {grade: 'A', scale: '| 75 - 100'},
            {grade: 'B', scale: '| 60 - 74'},
            {grade: 'C', scale: '| 45 - 59'},
            {grade: 'D', scale: '| 35 - 44'},
            {grade: 'E', scale: '| 15 - 34'},
            {grade: 'F', scale: '| 0 - 14'},
            {grade: 'Abs', scale: '| Abs'},
                     
        ],
        grades2: [
            { grade: '10', description: '| Excellent'},
            { grade: '9', description: '| Very Good'},
            { grade: '8', description: '| Good'},
            { grade: '7', description: '| Fair'},
            { grade: '6', description: '| Poor'},
            { grade: '5', description: '| Unsatisfactory'},
        ],         
        options: {
            itemsPerPage: -1,
        },  
        disabled: false,
        expand: false,
        overlay: false,
        search: '',
        width: '340', 
        coCurriculars: [],
        selectedCoCurriculars: [],
        disabledDeanComment: false,
        disableMusic: false,
        musicClasses: [],
        disableFormTeacherComment: false,
        formTeacherCommentMenu: false,
        deanCommentMenu: false,
        comments: [],
    }),
    methods: {
        ...mapActions({ 
            postTable1Record: 'termReports/postTable1Record',
            getTable2Records: 'termReports/getTable2Records', 
            setErrorResponse: 'termReports/setErrorResponse',
            getCoCurriculars: 'termReports/getCoCurriculars',
            getMusicClasses: 'termReports/getMusicClasses',
        }),        
        ...mapMutations({         
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setPagination: 'termReports/setPagination',           
            setLoading: 'termReports/setEditViewTermReportsLoading',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            setExpand: 'termReports/setEditViewTermReportsExpand',
        }),

        async initialize(){ 
            this.academicPeriod[0].value = this.academicYear;
            this.academicPeriod[1].value = this.termName;
            try {
                // const { data } = await this.getCoCurriculars();
                const [
                    { data: dataCoCurriculars },
                    { data: dataMusicClasses }
                ] = await Promise.all([
                    this.getCoCurriculars(),
                    this.getMusicClasses()
                ])

                this.coCurriculars = dataCoCurriculars;

                this.mapMusicClasses(dataMusicClasses)

                this.codedComments.forEach(record => {
                    this.comments.push({id: record.id, comment: record.detail})
                })
                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }  
        },

        mapMusicClasses (data){
            data.forEach(element => {
                this.musicClasses.push(element.form_class_id)
            })
        },


        async updateRecord(){
            console.log('updating...');
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            this.studentRecord.cocurricular = this.selectedCoCurriculars.join(',');

            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }
            
        },


        async recordNavigation(pagination){
            let response = null;
            this.setOverlay(true);
            this.setLoading(true);
            
            this.makePagination(pagination);
            this.setSelectedStudentRecord(this.table1Records[--pagination]);
            try {
                response = await this.getTable2Records();
                this.setTable2Records(response.data.table2_records);
                this.setStudentSubjects(response.data.student_subjects);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }            
            this.setOverlay(false);
            this.setLoading(false);           
        },

        makePagination(data){
            let prev_page = data;
            let current_page = data;
            let next_page = (current_page === this.pagination.last_page) ? null : ++data;
            prev_page = (current_page === 1) ? null : --prev_page;
            
            let pagination = {
                current_page: current_page,
                last_page: this.pagination.last_page,
                next_page: next_page,
                prev_page: prev_page,
            };
            this.setPagination(pagination);
        },

        async previousRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.prev_page);
        },

        nextRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.next_page);
        },

        cardWidth (item, index ){
            if(index == 1) return '100px';
            if(item.type == 'select') return '100px'
            return '65px'
        },

        setDisabledFields () {
            //default enable all fields
            this.disabled = false;
            this.disabledDeanComment = false;
            this.disableFormTeacherComment = false;

            this.recordSummary.forEach(element => {
                if(element.model != 'student_id')
                element.disabled = false;
            })

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && 
                !this.editTermReports
            ){
                this.disabled = true;
                this.disabledDeanComment = true;
                this.disableFormTeacherComment = true;
                this.recordSummary.forEach(element => {
                    element.disabled = true;
                })  
                console.log('enter 1');                  
                return;
            }

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) !== -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && 
                !this.editTermReports
            ){
                this.disabledDeanComment = true;
                console.log('enter 2');   
                return;
            }

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) !== -1 && 
                !this.editTermReports
            ){
                this.recordSummary.forEach(element => {
                    element.disabled = true;
                })   
                console.log('enter 3');                    
                return;
            }

            //not the form teacher and dont have permission to edit
            // if(this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && !this.editTermReports){
            //     //console.log('Not the form Teacher');
            //     this.disabled = true;
            //     this.disableFormTeacherComment = true;
            //     this.recordSummary.forEach(element => {
            //         element.disabled = true;
            //     })                    
            // }

            // if(this.deanFormClasses.length == 0){
            //     //not an assigned dean
            //     return;
            // }

            // if(this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && !this.editTermReports){
            //     //console.log('Not the Assigned Dean');
            //     this.disabledDeanComment = true;
            //     this.disableFormTeacherComment = true;
            // }
           
            
            
        },

        nextClass () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        checkNumber (model) {
            const validNumber = /^[0-9]+$/.test(this.studentRecord[model]);
            if(!validNumber){
                this.studentRecord[model] = null;
            }
        },

        removeGrade (model) {
            this.studentRecord[model] = null
            this.updateRecord();
        },

        setMusicAccess () {
            //open by default
            this.disableMusic = false;
            if(this.musicClasses.indexOf(this.studentRecord.class_id) === -1){
                this.disableMusic = true;
            }
        }
        
    },

   
}
</script>

<style scoped>
    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    ::v-deep .v-list--dense .v-list-item{
        min-height: 32px;
    }

    .v-btn__content{
        font-size: 0.9em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
        padding-left: 0 !important;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    ::v-deep .v-select__selection--comma{
        margin: 0 4px 4px 0;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-chip.v-size--default{
        height: 20px;
        font-size: 11px;
    }

    /* ::v-deep .times_late .v-chip.v-size--default{
        margin-top: 0;
    } */

    ::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{
            min-height: 8px;
        }

    ::v-deep .v-select.v-select--chips .v-select__selections{
        min-height: 8px;
    }

    ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot{
        padding: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-select__selections .v-chip{
        font-size: 10px;
        height: 20px;
    }

    ::v-deep .moral-education .v-input{
        width: 75px;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-chip--select .v-chip__content .v-icon{
        margin-left: 2px;
    }

    ::v-deep .v-textarea textarea{
        line-height: 1rem;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 2px;
    } */

    /* ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }     */

          /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: none;   /* Chrome, Safari, and Edge */
    appearance: none;           /* Standard property */
    text-align: center; 
    }

    ::v-deep .text-caption-1{
        font-size: 0.65rem;
    }

    ::v-deep .no-padding.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
        padding: 0;
    }

    /* ::v-deep .v-text-field--outlined fieldset{
        top: -3px;
    } */

    ::v-deep .v-sheet.v-sheet--outlined{
        border-color: red;
    }

</style>